import { resolveRuntimeEnvironment } from '@/utils/runtimeEnvironment';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const BannerStrip = styled(Box)(({ theme }) => ({
  padding: '2px 16px',
  textAlign: 'center',
  fontSize: '0.75rem',
  backgroundColor: theme.palette.warning.main,
  color: theme.palette.warning.contrastText,
}));

interface PreviewBannerProperties {
  readonly slug?: string;
}

export function PreviewBanner({ slug = import.meta.env.VITE_PREVIEW_SLUG }: PreviewBannerProperties) {
  const previewSlug = resolveRuntimeEnvironment(slug, '');
  if (!previewSlug) {
    return;
  }

  return <BannerStrip role='note'>A preview of Physna V3, brought to you by {previewSlug}</BannerStrip>;
}
